import { render, staticRenderFns } from "./landing-page.vue?vue&type=template&id=29e1c8ac&scoped=true&lang=pug&"
import script from "./landing-page.vue?vue&type=script&lang=js&"
export * from "./landing-page.vue?vue&type=script&lang=js&"
import style0 from "./landing-page.vue?vue&type=style&index=0&id=29e1c8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e1c8ac",
  null
  
)

export default component.exports